<template>
  <div class="rounded bg-grey_3 bordered pa-3 my-3" v-if="article.visible_accueil == '1'">
    <div class="d-flex flex-sm-row flex-start align-top flex-md-nowrap flex-wrap gap">
      <v-carousel class="thumbnail_carousel" :show-arrows="false"
        :hide-delimiters="article.url_image_2 == '' && article.url_image_3 == ''" height="200" color="white"
        style="width: 200px !important; min-width: 200px">
        <v-carousel-item class="carousel-article-item" v-if="article.url_image != ''" :src="article.url_image"
          @click="zoom(article.url_image)" cover></v-carousel-item>
        <v-carousel-item class="carousel-article-item" v-if="article.url_image_2 != ''" :src="article.url_image_2"
          @click="zoom(article.url_image_2)" cover></v-carousel-item>
        <v-carousel-item class="carousel-article-item" v-if="article.url_image_3 != ''" :src="article.url_image_3"
          @click="zoom(article.url_image_3)" cover></v-carousel-item>

      </v-carousel>
      <div class="d-flex flex-column justify-start flex-wrap">
        <h5 class="font-weight-bold">{{ article.nom }}</h5>
        <div v-html="article.description"></div>
        <div class="text-body-1">
          <i>Disponible en: {{ list_tailles_text }}</i>
          <v-tooltip v-if="article.get_metadata('popup_info_supp_taille')">
            <u>Guide des tailles</u>
            <div v-html="article.get_metadata('popup_info_supp_taille')"></div>
            <template v-slot:activator="{ props }">
              <v-btn density="compact" size="small" class="ml-2" color="primary-dark" variant="elevated" elevation="1"
                v-bind="props" icon="mdi-help"></v-btn>
            </template>
          </v-tooltip>
        </div>

        <div class="text-h6">
          <span v-if="parseInt(article.prix) > 0">{{ article.prix }}€</span><span v-else>Gratuit</span>
        </div>
        <div class="d-flex flex-column justify-start">
          <div v-if="mainStore.billetterie_mode" class="mb-3">
            <v-btn class="inscription_btn shadowed"
              v-if="article.is_selectionnable(mainStore.module.status, mainStore.view_as_admin, mainStore.inscription_as_admin, mainStore?.inscription_vip?.is_valid())"
              size="small" variant="tonal" @click="$router.push({ name: 'Inscriptions' })"><v-icon icon="mdi-cart"
                class="mr-2"></v-icon> Commander</v-btn>
            <v-btn v-else class="shadowed" color="dark-red" size="small" variant="tonal"><v-icon
                icon="mdi-pencil-off-outline"></v-icon> Indisponible</v-btn>
          </div>
        </div>

      </div>
    </div>
    <v-dialog v-model="zoomDialog" width="400" scroll-strategy="none">
      <v-card class="pa-2">
        <v-img style="width:100%;height:auto;margin:auto;" :src="zoomOn"></v-img>
        <v-btn @click="zoomDialog = false">Fermer</v-btn>
      </v-card>

    </v-dialog>

  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  props: ["article"],
  data() {
    return {
      zoomDialog: false,
      zoomOn: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_tailles_text() {
      let join = this.article.sizes.map((taille) => taille.nom).join(", ");
      return join != "" ? join : "Taille unique";
    },
  },
  methods: {
    zoom(url) {
      this.zoomOn = url;
      this.zoomDialog = true;
    }
  }
};
</script>

<style lang="scss" >
.thumbnail_article {
  width: auto;
  height: 200px;
  border-radius: 5px;
}
.carousel-article-item img {
  cursor: zoom-in !important;
}
</style>